import { Text } from "@chakra-ui/react";
import { Box, Flex } from "@chakra-ui/layout";
import FullCalendar, {
  EventClickArg,
  EventContentArg,
} from "@fullcalendar/react"; //listMonth, listWeek, listDay, listYear
import moment from "moment";
import { useRef, useState } from "react";
import colors from "core/resources/theme/colors";
import Calendar from "components/Calendar";
import HeaderTable from "components/Page/HeaderTable";
import { useLoading } from "components/GlobalLoading";
import { FiltroManutencao } from "./../ListagemManutencaoTable/hooks/useFiltroManutencao";
import {
  ManutencaoDto,
  CalendarioManutencaoEvent,
} from "features/manutencao/typings/index";

import OutlineButton from "components/Button/OutlineButton";
import { StatusManutencaoEnum } from "features/manutencao/typings";

interface CalendarioManutencaoProps {
  manutencoes?: ManutencaoDto[];
  onClick: (manutencao: ManutencaoDto) => any;
  onChangeView?: () => any;
  loading?: boolean;
  onChangeDate: (start: string, end: string) => any;
  hideSearch?: boolean;
  hideOptionsView?: boolean;
  dateClick?: (data: string) => any;
  filtro: FiltroManutencao;
  onChangeFiltro: (filtro: Partial<FiltroManutencao>) => any;
}

function CalendarioManutencao({
  manutencoes = [],
  onClick,
  onChangeView,
  loading = false,
  onChangeDate,
  hideSearch,
  hideOptionsView,
  dateClick,
  filtro,
  onChangeFiltro,
}: CalendarioManutencaoProps) {
  const [, setLocalView] = useState("dayGridMonth");
  const calendarRef = useRef<FullCalendar | null>(null);

  const _eventos: CalendarioManutencaoEvent[] | undefined =
    manutencoes?.map((manutencao) => ({
      ...manutencao,
      title: manutencao.nome,
      backgroundColor: "none",

      start: moment(manutencao.data).startOf("day").toISOString(),
      end: moment(manutencao.data).startOf("day").toISOString(),
    })) || [];

  const getReservaFromClickEvent = ({
    event,
  }: EventClickArg): ManutencaoDto => {
    return {
      id: event._def.publicId,
      equipamentos: event._def.extendedProps.equipamentos,
      intervaloRepeticao: event._def.extendedProps.intervaloRepeticao,
      nome: event._def.extendedProps.nome,
      periodicidade: event._def.extendedProps.periodicidade,
      responsavelTecnico: event._def.extendedProps.responsavelTecnico,
      tipoIntervaloRepeticaoId:
        event._def.extendedProps.tipoIntervaloRepeticaoId,
      status: event._def.extendedProps.status,
      data: event._def.extendedProps.data,
      dataPrevistaInicial: event._def.extendedProps.dataPrevistaInicial,
      dataRealizacao: event._def.extendedProps.dataRealizacao,
    };
  };

  const handleEventClick = (event: EventClickArg) => {
    const manutencao = getReservaFromClickEvent(event);
    onClick(manutencao);
  };

  useLoading(loading);

  return (
    <>
      <Box
        boxShadow={"0 0 16px 3px rgba(0, 0, 0, 0.05)"}
        rounded="16px"
        mb="32px"
        p={2}
        bg={colors.white}
      >
        {!hideSearch ? (
          <Box mb={6}>
            <HeaderTable
              value={filtro.search || ""}
              onSearch={(v) => onChangeFiltro({ search: v })}
            >
              <Flex justifyContent="end" w="100%">
                <Flex gap={4}>
                  <OutlineButton
                    color={colors.gray}
                    border={`solid 1px ${colors.gray}`}
                    bg="none"
                    onClick={onChangeView}
                    gap={2}
                  >
                    Lista
                  </OutlineButton>
                  <OutlineButton
                    color={colors.primary}
                    bg="none"
                    onClick={onChangeView}
                    gap={2}
                  >
                    Mês
                  </OutlineButton>
                </Flex>
              </Flex>
            </HeaderTable>
          </Box>
        ) : null}
        <Calendar
          renderEventContent={renderEventContent}
          ref={calendarRef}
          dateClick={dateClick}
          events={_eventos}
          setLocalView={setLocalView}
          handleEventClick={handleEventClick}
          hideOptionsView={hideOptionsView}
          onChangeDate={onChangeDate}
          displayEventTime={false}
          loading={loading}
          centerTitle
        />
      </Box>
    </>
  );
}

function renderEventContent(eventInfo: EventContentArg) {
  const _eventProps = eventInfo.event._def.extendedProps as ManutencaoDto;
  const isCalendarView = eventInfo.view.type === "dayGridMonth";
  return (
    <Flex
      title={eventInfo.event.title}
      ml={isCalendarView ? 0 : -6}
      rounded={isCalendarView ? "full" : "10px"}
      border="solid 1px"
      px={2}
      color={
        _eventProps.status.id === StatusManutencaoEnum.Concluida
          ? "green"
          : _eventProps.status.id === StatusManutencaoEnum.Pendente &&
            moment(_eventProps.data).isBefore(moment(), "day")
          ? "red "
          : "orange"
      }
      bg="none"
      cursor="pointer"
      _hover={{
        boxShadow: `0 0 0 2px ${colors.primary}`,
        outlineColor: colors.primary,
      }}
      alignItems="center"
      h="28px"
    >
      {isCalendarView ? (
        eventInfo.event.title
      ) : (
        <Text
          flex={1}
          as="h4"
          color={isCalendarView ? colors.white : colors.primary}
          fontWeight={isCalendarView ? "none" : "bold"}
        >
          {_eventProps.responsavelTecnico.nome}
        </Text>
      )}

      {isCalendarView ? null : (
        <Text flex={1} as="h4" color={colors.primary} fontWeight="bold">
          {_eventProps.status}
        </Text>
      )}
    </Flex>
  );
}

export default CalendarioManutencao;
